/* eslint-disable import/no-duplicates */
import { addDays, format, parse, parseISO, startOfDay, subMonths } from 'date-fns';
import RU from 'date-fns/locale/ru';

/* eslintenable import/no-duplicates */
import { Validator } from 'utils/validate';

import { toDate } from 'bloko/blocks/calendar/datesHelper';

type IsValidDateIntervalFunction = (errorMessage: string, dateFrom: string | undefined) => Validator;

export const isValidDateInterval: IsValidDateIntervalFunction = (errorMessage, dateFrom) => (dateTo) => {
    if (!dateFrom || !dateTo) return errorMessage;
    const startDate = toDate(dateFrom);
    const endDate = toDate(dateTo);
    return startDate > endDate ? errorMessage : undefined;
};

export const getTomorrowDate = (): Date => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
};

export const getEarliestDate = (dates: string[]): string | undefined => {
    if (dates.length === 0) return undefined;

    return dates.reduce((earliest, current) => (toDate(current) < toDate(earliest) ? current : earliest));
};

export const getLatestDate = (dates: string[]): string | undefined => {
    if (dates.length === 0) return undefined;

    return dates.reduce((latest, current) => (toDate(current) > toDate(latest) ? current : latest));
};

export const getMinDate = (dates: Date[]): Date | undefined => {
    if (dates.length === 0) return undefined;

    return dates.reduce((minDate, current) => (current < minDate ? current : minDate));
};

export const getMaxDate = (dates: Date[]): Date | undefined => {
    if (dates.length === 0) return undefined;

    return dates.reduce((maxDate, current) => (current > maxDate ? current : maxDate));
};

export const previousMonth = subMonths(new Date(), 1);

const DEFAULT_FORMAT = 'yyyy-MM-dd';

type FormatDate = (date: Date | string, formatStr?: string) => string;

export const formatDate: FormatDate = (date, formatStr = DEFAULT_FORMAT) => {
    if (typeof date === 'string') {
        date = parseISO(date);
    }
    return format(date, formatStr, {
        locale: RU,
    });
};

type GetDateFromString = (stringDate?: string | null, formatStr?: string) => Date | undefined;

export const getDateFromString: GetDateFromString = (stringDate, formatStr = DEFAULT_FORMAT) =>
    stringDate ? parse(stringDate, formatStr, new Date()) : undefined;

export const TODAY_START_OF_DAY = startOfDay(new Date());

export const TODAY_FORMATTED = formatDate(new Date());
export const NEXT_WEEK_FORMATTED = formatDate(addDays(new Date(), 7));
